import { render, staticRenderFns } from "./PurchasesTitle.vue?vue&type=template&id=15eaf156&scoped=true"
import script from "./PurchasesTitle.vue?vue&type=script&lang=js"
export * from "./PurchasesTitle.vue?vue&type=script&lang=js"
import style0 from "./PurchasesTitle.vue?vue&type=style&index=0&id=15eaf156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15eaf156",
  null
  
)

export default component.exports